import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { colors } from '../theme/colors';

const Shell = styled.main`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 24px;
  background: ${colors.bg};
  color: ${colors.ink};
  text-align: center;
`;

const Title = styled.h1`
  margin: 0;
  font-size: 28px;
  font-weight: 900;
`;

const Text = styled.p`
  margin: 0;
  color: ${colors.inkMuted};
  font-size: 15px;
`;

const HomeLink = styled(Link)`
  margin-top: 8px;
  color: ${colors.accent};
  font-weight: 800;
  text-decoration: none;
  &:hover { text-decoration: underline; }
`;

export default function NotFoundPage() {
  return (
    <Shell>
      <Title>Page not found</Title>
      <Text>The page you requested does not exist or has moved.</Text>
      <HomeLink to="/">Back to home</HomeLink>
    </Shell>
  );
}
